import { Suspense, type ReactNode } from 'react';
import { LoadingState } from '../components/states/LoadingState';

export type LazyRouteProps = {
  children: ReactNode;
};

/**
 * Suspense boundary around a lazily loaded route element.
 *
 * One per route rather than one around the whole router, so a slow chunk
 * shows a busy state where the page will be — inside the shell, with the
 * navigation still usable — instead of blanking the entire app.
 *
 * Its own file because `router.tsx` exports the router (a constant), and a
 * component declared beside a non-component export breaks React Fast Refresh.
 */
export function LazyRoute({ children }: LazyRouteProps) {
  return <Suspense fallback={<LoadingState message="Loading page…" />}>{children}</Suspense>;
}
